import { DEFAULT_ROBOT_MODEL, FIRE_ALARM_USE_ICON } from "../../utils/const";
import parcel from "../../assets/parcel.png";
import estopIcon from "../../assets/info.png";
import fireAlarmIcon from "../../assets/fire-button.png";
import { getRobotImage } from "./mock-robots";
import cleaningIcon from "../../assets/cleaning/clean-icon.png"

export const getDeliveryIcon = () => {
  return parcel;
}

export const getEstopIcon = () => {
  return estopIcon;
}

export const getFireAlarmIcon = () => {
  return fireAlarmIcon;
}

export const getCleaningIcon = () => {
  return cleaningIcon;
}

export const getJobImageIcon = (robotModel: string) => {
  if (FIRE_ALARM_USE_ICON) {
    return getDeliveryIcon()
  }

  return getRobotImage(robotModel || DEFAULT_ROBOT_MODEL);
}